
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component
export default class ShoplLicenseModal extends Vue {
  visible = false;

  labelCol = { span: 8 };

  wrapperCol = { span: 10 };


  @lazyInject(ShopService)
  shopService!: ShopService;

  form: any = {
    credit_code: '',
    company_name: '',
    company_type: '',
    legal_person: '',
    shop_id: '',
    poi: '',
  };

  @Prop()
  detail!: any;

  @Prop()
  labelId!: any;

  init() {
    this.visible = true;
    const { credit_code, company_name, company_type, legal_person, shop_id, poi } = JSON.parse(JSON.stringify(this.detail));
    // console.log(this.detail);
    this.form = {
      credit_code,
      company_name,
      company_type,
      legal_person,
      shop_id,
      poi,
      label_id: this.labelId,
    };
  }

  handleCancel() {
    this.visible = false;
  }

  async handleOk() {
    // console.log(this.form);
    const res = await this.shopService.postUpdateBusinessLicense(this.form);
    if (res) {
      this.$message.success('操作成功');
      this.visible = false;
      this.$emit('refresh');
    }
  }
}
